var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("RouteLocationDetail", {
        attrs: {
          detail: _vm.selectedLocation,
          index: _vm.selectedLocationIndex
        },
        on: { save: _vm.setLocationDetail }
      }),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "Route" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          type: "number",
                          toggle: "",
                          disabled: _vm.insertReadonly.StatusId
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("insert.detail"), active: "" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RepresentativeId",
                            error: _vm.$v.form.RepresentativeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              searchable: "",
                              url:
                                "VisionNextEmployee/api/Employee/AutoCompleteSearch",
                              orConditionFields:
                                "Code,Description1,Name,Surname",
                              customOption: true,
                              "is-employee": true,
                              disabled: _vm.insertReadonly.RepresentativeId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "RepresentativeId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "VehicleId",
                            error: _vm.$v.form.VehicleId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              label: "VehiclePlateNumber",
                              url:
                                "VisionNextVehicle/api/Vehicle/AutoCompleteSearch",
                              disabled: _vm.insertReadonly.VehicleId,
                              "dynamic-and-condition": { StatusIds: [1] },
                              "page-count": 1000
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "VehicleId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RouteTypeId",
                            error: _vm.$v.form.RouteTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextRoute/api/RouteType/Search",
                              disabled: _vm.insertReadonly.RouteTypeId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "RouteTypeId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "VisitStartControlId",
                            error: _vm.$v.form.VisitStartControlId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "VISIT_START_CONTROL",
                              disabled: _vm.insertReadonly.VisitStartControlId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "VisitStartControlId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.route.customerArea"),
                            required: !!_vm.showCustomerRegion,
                            error: _vm.$v.form.CustomerRegion5Id
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "CUSTOMER_REGION_5",
                              disabled:
                                !_vm.showCustomerRegion ||
                                _vm.insertReadonly.CustomerRegion5Id
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedLabelType(
                                  "CustomerRegion5Id",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.CustomerRegion5Id,
                              callback: function($$v) {
                                _vm.CustomerRegion5Id = $$v
                              },
                              expression: "CustomerRegion5Id"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.route.marketingArea"),
                            required: !!_vm.showMarketingRegion,
                            error: _vm.$v.form.MarketingRegion5Id
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "MARKETING_REGION_5",
                              disabled:
                                !_vm.showMarketingRegion ||
                                _vm.insertReadonly.CustomerRegion5Id
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedLabelType(
                                  "MarketingRegion5Id",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.MarketingRegion5Id,
                              callback: function($$v) {
                                _vm.MarketingRegion5Id = $$v
                              },
                              expression: "MarketingRegion5Id"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CityId",
                            error: _vm.$v.form.CityId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "CITY",
                              disabled: _vm.insertReadonly.CityId
                            },
                            on: { input: _vm.selectedCity }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DistrictId",
                            error: _vm.$v.form.DistrictId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              source: _vm.distiricts,
                              disabled: _vm.insertReadonly.DistrictId,
                              label: "Label"
                            },
                            on: { input: _vm.selectedDistirict },
                            model: {
                              value: _vm.district,
                              callback: function($$v) {
                                _vm.district = $$v
                              },
                              expression: "district"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ParishIds",
                            error: _vm.$v.form.ParishIds
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              multiple: "",
                              source: _vm.avenues,
                              disabled: _vm.insertReadonly.ParishIds,
                              label: "Label"
                            },
                            on: { input: _vm.selectedParish }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "IsSuperRoute",
                            error: _vm.$v.form.IsSuperRoute
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.IsSuperRoute
                            },
                            model: {
                              value: _vm.form.IsSuperRoute,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "IsSuperRoute", $$v)
                              },
                              expression: "form.IsSuperRoute"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "IsMultidayRoute",
                            error: _vm.$v.form.IsMultidayRoute
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.IsMultidayRoute
                            },
                            model: {
                              value: _vm.form.IsMultidayRoute,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "IsMultidayRoute", $$v)
                              },
                              expression: "form.IsMultidayRoute"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: { lazy: "", title: _vm.$t("insert.route.locations") }
                },
                [
                  _c(
                    "NextDetailPanel",
                    {
                      attrs: {
                        items:
                          _vm.form.IsSuperRoute === 1
                            ? _vm.locationItems2
                            : _vm.locationItems1,
                        "edit-form": _vm.editForm,
                        "detail-buttons": _vm.detailButtons
                      },
                      model: {
                        value: _vm.form.RouteDetails,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "RouteDetails", $$v)
                        },
                        expression: "form.RouteDetails"
                      }
                    },
                    [
                      _c("template", { slot: "grid" }, [
                        _c(
                          "div",
                          { attrs: { cols: "12", md: "2" } },
                          [
                            _c("NextMultipleSelection2", {
                              attrs: {
                                name: "RouteMultipleCustomer",
                                "hidden-values": _vm.hiddenValues,
                                "dynamic-disabled-filters":
                                  _vm.dynamicDisabledFilters,
                                "change-branch-id": true,
                                "record-count": 20,
                                "after-func": _vm.editForm
                              },
                              model: {
                                value: _vm.form.RouteDetails,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "RouteDetails", $$v)
                                },
                                expression: "form.RouteDetails"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-329b0f3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-329b0f3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Route/insert.vue
// module id = null
// module chunks = 